import { jsx as _jsx } from "react/jsx-runtime";
import EducationClassroom from "./EducationClassroom";
export default function EduReading() {
    return (_jsx(EducationClassroom, { subject: "reading", title: "Reading Classroom", description: "Practice reading comprehension, vocabulary, context clues, main ideas, and literary analysis with Ava.", placeholder: "Ask a reading question or paste a passage for comprehension help." }));
}
